export default __webpack_public_path__ + "static/SRUS STDXX - Product Specifications & Technical Data-6aaa8a0acb760f9f90deee20d880ba49.pdf";